import { render, staticRenderFns } from "./CHeader.vue?vue&type=template&id=c9c8d960&scoped=true&"
import script from "./CHeader.vue?vue&type=script&lang=ts&"
export * from "./CHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CHeader.vue?vue&type=style&index=0&id=c9c8d960&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c8d960",
  null
  
)

export default component.exports